// Currently this component only for info-trac proj, but in future possibly can add variant: 'infoTrac' | 'guidance',
// and render different styles additionally.

import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../../utils/styles';
import { StatusesEnum, StatusesType } from '../../../infoTrac/types';
import { getColorMixTransparentProp } from '../../../utils';

const badgeStatusVariants = cva(
  [
    'w-28 inline-flex items-center justify-center', // h-8
    'rounded-[20px] border px-2.5 py-0.5',
    'text-base font-medium transition-colors',
    'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    'border-0',
    'relative',
  ],
  {
    variants: {
      variant: {
        filled: '',
        transparent: [
          'justify-start pl-4 before:absolute before:content-[""] before:top-50 before:left-0',
          'before:h-[10px] before:w-[10px] before:bg-current before:rounded-full',
        ],
      },
      status: {
        pending: 'text-status-pending',
        done: 'text-status-done',
        completed: 'text-status-completed',
        running: 'text-status-running',
        earlyDrop: 'text-status-earlyDrop',
        late: 'text-status-late',
        approved: 'text-status-approved',
        scheduled: 'text-status-scheduled',
        draft: 'text-status-draft',
        delivered: 'text-status-delivered',
        active: 'text-status-completed',
        inactive: 'text-status-draft',
      },
    },
    defaultVariants: {
      variant: 'filled',
      status: 'pending',
    },
  },
);

export interface BadgeStatusProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeStatusVariants> {
  status: StatusesType;
}

function StatusBadge({ status, variant, className, ...props }: BadgeStatusProps) {
  return (
    <div
      className={cn(badgeStatusVariants({ status, variant }), className)}
      style={
        variant === 'transparent'
          ? { backgroundColor: 'transparent' }
          : {
              backgroundColor: getColorMixTransparentProp(`var(--${status})`, 15),
            }
      }
      {...props}
    >
      {StatusesEnum[status]}
    </div>
  );
}

export { StatusBadge, badgeStatusVariants };
